import { Icon } from '@dev-spendesk/grapes';
import cx from 'classnames';
import React from 'react';

import styles from './PreviewStep.module.css';

type Props = {
  title: string;
  description: string;
};

export const PreviewStep = ({ title, description }: Props) => (
  <div className={cx(styles.PreviewStep, 'flex gap-24')}>
    <div>
      <div className="h-[24px] rounded-12 bg-background-primary-brand-default p-4 text-content-complementary">
        <Icon name="arrow-down" />
      </div>
      <div className={styles.Separator} />
    </div>
    <div className="text-left">
      <p className="mb-8 text-content-primary title-xl">{title}</p>
      <p className="text-content-secondary-bg-primary body-m">{description}</p>
    </div>
  </div>
);
